import { useSyncExternalStore } from "react";

/** A 1 Hz clock shared by every widget (spec §9.7): computed props refresh without ticking the doc (I-6). */
let now = Date.now();
const subs = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function tick() {
  now = Date.now();
  for (const s of subs) s();
}

export function useNow(): number {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      if (!timer) timer = setInterval(tick, 1000);
      return () => {
        subs.delete(cb);
        if (!subs.size && timer) {
          clearInterval(timer);
          timer = null;
        }
      };
    },
    () => now,
    () => now,
  );
}
